var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgText(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.125 12.8076L5.34375 1.55762L9.5625 12.8076M8.08594 8.87012H2.60156M11.4609 6.62012C11.8895 5.61148 12.9023 4.93262 14.0625 4.93262C15.6797 4.93262 16.875 6.05762 16.875 7.74512V12.8076",
    stroke: "#FF6B00",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 10.8037C11.25 12.0693 12.1943 12.8428 13.3594 12.8428C15.2578 12.8428 16.875 11.8936 16.875 9.11621V8.58887C16.1719 8.58887 14.8359 8.62402 13.6406 8.76465C12.4886 8.90035 11.25 9.43262 11.25 10.8037Z",
    stroke: "#FF6B00",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

export default SvgText;